import { useState, useEffect } from "react";

/*gets the screen dimensions from the window object*/
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

/*
returns the width and height of the screen
*/
export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [window]);

  return windowDimensions;
}

//defines breakpoints for the screen
export const smBreakPoint = 640;
export const mdBreakPoint = 768;
export const lgBreakPoint = 1024;
export const xlBreakPoint = 1280;
export const xxlBreakPoint = 1536;
